import React, { useState } from 'react';
import { handlePointerDown} from '../../lib/modal-helper';
import { selectAllStrings } from '../language/languageSlice';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faBolt, faCrown } from '@fortawesome/free-solid-svg-icons';
import '../../stylesheets/TrialEndModal.css';
import '../../stylesheets/FullAccessModal.css';
import { loggedOut, createiOSUser, login } from './userSlice';
import { useHistory } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';
import ErrorMessage from '../../app/ErrorMessage';
import { getUdid } from '../../api/mobile';
import constants from '../../constants';

const FullAccessModal = ({onClose}) => {
    const strings = useSelector(selectAllStrings);

    const dispatch = useDispatch();
    const history = useHistory();
    const [buyRequestStatus, setBuyRequestStatus] = useState('idle');
    const [error, setError] = useState('');
    
    const closeModal = (event) => {
        event.preventDefault();
        onClose();
    };
    
    const generateFakeEmail = () => {
        var chars = 'abcdefghijklmnopqrstuvwxyz1234567890';
        var string = '';
        for(var ii=0; ii<15; ii++){
            string += chars[Math.floor(Math.random() * chars.length)];
        }
        return string + '@bitage.com';
    };
    const buyClicked = async event => {
        event.preventDefault();
        try {
                setBuyRequestStatus('pending');

                const resultAction = await dispatch(createiOSUser({
                    nome: 'fake',
                    cognome: 'fake',
                    email: generateFakeEmail()
                }));
                unwrapResult(resultAction);

                let id = resultAction.payload.id;
                let userLogin = resultAction.payload.user_login;
                let email = resultAction.payload.email;
                if (id > 0) {
                let url = `_inapppurchase_${id}_${userLogin}_${email}`;
                
                window.inappjson = async function(pwd) {
                    const udid = await getUdid();
                    await dispatch(login({
                        udid,
                        cardNumber: userLogin,
                        password: pwd
                    }));
                    window.localStorage.setItem('username', userLogin);
                    window.localStorage.setItem('password', pwd);
                    
                    window.location = '/#/thank-you';
                };
                window.location.href = url;
            } else {
                
            }

            } catch (err) {
                setError(err.message);
                setBuyRequestStatus('idle');
            }
    };
    

    return error.length > 0 ? <ErrorMessage strings={strings} message={error} onGoBack={() => setError('')}/> : 
            <div className="modal" id="trial_end_modal">
        <div className="modal-body" id="trial_end_modal_body">
            <div className="modal-border" onPointerDown={event => handlePointerDown(event, 'trial_end_modal_body')}>
                <div className="move-handler"></div>
            </div>
            <div className="modal-content">
                <div className="modal-header" onPointerDown={event => handlePointerDown(event, 'trial_end_modal_body')}>
    
                    <a className="close-modal" onPointerDown={event => {
                                event.preventDefault();
                                event.stopPropagation();
                               }} onClick={closeModal}>X</a>
                    <span onPointerDown={event => event.preventDefault()}>{strings.app_full_access}</span>
                    <hr/>
                </div>
                <div className="modal-text">{strings.buy_access_for}</div>
                <div className="access-price">9.99€/{strings.year}</div>
                <div className="advantage-list">
                    <div className="advantage">
                        <div className="icon">
                            <FontAwesomeIcon icon={faThumbsUp}/>
                        </div>
                        <div className="intro">
                            <div className="title">{strings.points_of_interest}</div>
                            <div className="description">{strings.access_to_pois}</div>
                        </div>
                    </div>
                    <div className="advantage">
                        <div className="icon">
                            <FontAwesomeIcon icon={faBolt}/>
                        </div>
                        <div className="intro">
                            <div className="title">{strings.advantages}</div>
                            <div className="description">{strings.vizualization_of_structures}</div>
                        </div>
                    </div>
                    <div className="advantage">
                        <div className="icon">
                            <FontAwesomeIcon icon={faCrown}/>
                        </div>
                        <div className="intro">
                            <div className="title">{strings.constant_updates}</div>
                            <div className="description">{strings.fast_and_punctual}</div>
                        </div>
                    </div>
                </div>
                <button className="btn" id="buy_card" onClick={buyClicked} disabled={buyRequestStatus === 'pending'}>
                {buyRequestStatus === 'pending' ? <div className="loader"></div> : strings.buy_access}
                </button>
                <div className="support">{strings.for_any} <a href="tel:0685305377">0685305377</a> 
                
    {constants.environment == 'iOS' ? null : 
            <React.Fragment>{strings.or_write}
    <a href="mailto:info@pleinairclub.it">info@pleinairclub.it</a></React.Fragment>
            
    } 
                 </div>
            </div>
        </div>
    </div>;
};

export default FullAccessModal;

